export * from "./WeirdStarWithChildren";
